/* Kontakt: e-postadressen kopieres med ett klikk.
 *
 * Feiler utklippstavlen (den krever sikker kontekst og en brukerhandling),
 * faller vi tilbake til å åpne e-postklienten, som er det brukeren ville. */

import gsap from 'gsap';
import { $, $$, mindreBevegelse } from '../kjerne/verktoy.js';

export function startKontakt() {
  for (const knapp of $$('[data-kopier]')) {
    const melding = knapp.parentElement.querySelector('.kopier-melding');

    knapp.addEventListener('click', async () => {
      const adresse = knapp.dataset.kopier;
      try {
        await navigator.clipboard.writeText(adresse);
      } catch {
        location.href = 'mailto:' + adresse;
        return;
      }
      knapp.classList.add('kopiert');
      if (melding) melding.textContent = `${adresse} er kopiert`;
      setTimeout(() => {
        knapp.classList.remove('kopiert');
        if (melding) melding.textContent = '';
      }, 1800);
    });
  }

  if (mindreBevegelse.matches) return;

  gsap.from('.kontakt-knapper > *, .kontakt-rad > *', {
    y: 30, opacity: 0, stagger: .07, duration: 1, ease: 'expo.out',
    scrollTrigger: { trigger: '.kontakt-knapper', start: 'top 90%' },
  });
}
